import { LngLat, YMapLocationRequest } from "@yandex/ymaps3-types"

export function fetchLocation(): YMapLocationRequest {
	return {
		center: fetchCoordinates(),
		zoom: 15,
		duration: 200,
		easing: "ease-in-out",
	}
}

export function fetchCoordinates(): LngLat {
	const coordinates = [45.035967, 38.966447].reverse()
	return [coordinates[0], coordinates[1]]
}
